<div class="name-description" [resBusySpinner]="isBusy" [message]="isBusyMessage">
    <div class="modal-row"
        [ngClass]="[customClassRow == 'inline' ? 'inline-display-full-width-name' : '', isDescriptionHidden ? 'additional-bottom-padding' : '']">
        <div class="modal-row-column-auto" [ngClass]="{'name-inline': customClassRow == 'inline'}">
            <label [ngStyle]="{'width.px': customLabelWidth ? customLabelWidth : '70'}"
                [attr.data-automation-id]="automationId + '-name-label'" for="name" requiredAsterisk
                [isRequired]="!isNameDisabled">{{nameLabel}}
            </label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" id="name" [(ngModel)]="name" [attr.data-automation-id]="automationId + '-name-input'"
                name="name" [attr.maxlength]="maxNameLength" [disabled]="isNameDisabled"
                (ngModelChange)="onNameChanged()" (focusout)="onNameFocusLost($event)" (click)="onFocus()"
                [(resScrollablePopover)]="showErrorPopover" [popoverErrorMessage]="validateNameError"
                [isSingleLine]="errPopoverSingleLine" popoverType="error" [popoverStickyClass]="popoverStickyClass"
                popoverPlacement="bottom" [popoverAutomationId]="automationId + '-error-label'" [title]="tooltipName"
                [ngClass]="{'red-background': changeInputStyleWhenNotValid && formValid === false && name}">
        </div>
    </div>
    <ng-container *ngTemplateOutlet="middleRowTemplate"></ng-container>
    <div class="modal-row" [ngClass]="{'inline-display-full-width-description': customClassRow == 'inline'}"
        [hidden]="isDescriptionHidden">
        <div class="modal-row-column-auto"><label [ngStyle]="{'width.px': customLabelWidth ? customLabelWidth : '70'}"
                [attr.data-automation-id]="automationId + '-description-label'" for="description">Description:</label>
        </div>
        <div class="modal-row-column-max description" [ngClass]="{'description-inline': customClassRow == 'inline'}">
            <textarea id="description" [(ngModel)]="description"
                [attr.data-automation-id]="automationId + '-description-input'" [disabled]="isDescriptionDisabled"
                [attr.maxlength]="maxDescriptionLength" name="description" (ngModelChange)="onDescriptionChanged()"
                (focusout)="onDescriptionFocusLost()"></textarea>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="bottomRowTemplate"></ng-container>
</div>